/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Saved_TagsInputs */

const en_dialog_saved_tags = /** @type {(inputs: Dialog_Saved_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved Tags`)
};

const es_dialog_saved_tags = /** @type {(inputs: Dialog_Saved_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiquetas guardadas`)
};

/**
* | output |
* | --- |
* | "Saved Tags" |
*
* @param {Dialog_Saved_TagsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_saved_tags = /** @type {((inputs?: Dialog_Saved_TagsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Saved_TagsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_saved_tags(inputs)
	return en_dialog_saved_tags(inputs)
});